/**
 * Search input for Organisation Management.
 *
 * Extracted from OrganisationManagementPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import { Search } from 'lucide-react'

interface OrganisationSearchBarProps {
  searchQuery: string
  setSearchQuery: (q: string) => void
}

export function OrganisationSearchBar({
  searchQuery,
  setSearchQuery,
}: OrganisationSearchBarProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="relative">
      <Search className="absolute top-1/2 left-3 h-5 w-5 -translate-y-1/2 text-stone-400" />
      <input
        type="text"
        placeholder={t('organisations.searchPlaceholder')}
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value)
        }}
        className="w-full rounded-lg border border-stone-200 bg-white py-2 pr-4 pl-10 focus:ring-2 focus:ring-[#4e5e82] focus:outline-none dark:border-stone-700 dark:bg-stone-800"
      />
    </div>
  )
}
